import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { DestinationFolderData, DestinationFolderParams } from 'wizards/models/destination-models';
import { RemoteManagementWizardsService } from 'wizards/services/remote-management-wizards.service';
import { StepBase } from 'wizards/steps/StepBase.class';
import { DestinationTableData } from 'wizards/steps/components/destination-table/destination-table.component';

@Directive()
export class BaseForDestinationStep<T> extends StepBase<T> {
  mainService: RemoteManagementWizardsService;

  @Input() isVirtual: boolean;

  public forceValidate = false;
  public overwriteAndSpecific: DestinationTableData;

  public destinationFolderParams: DestinationFolderParams;
  public destinationFolderData: DestinationFolderData = { destinationFolder: '', valid: false };

  destinationFolderValidator(control: AbstractControl): ValidationErrors | null {
    const isRequired = Validators.required(control);
    return isRequired ? isRequired : this.destinationFolderData.valid ? null : { invalidPath: true };
  }

  constructor() {
    const mainService = inject(RemoteManagementWizardsService);

    super();

    this.mainService = mainService;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  initForm(): void {}

  destinationFolderDataChangeHandler(name = 'destinationFolder', dataName = 'destinationFolderData'): void {
    this.stepForm.get(name).setValue(this[dataName].destinationFolder);
    this.stepForm.get(name).updateValueAndValidity();
  }

  getParamsForDestinationFolder(): DestinationFolderParams {
    const toDiff = !!this.mainService?.targetComputerData;
    return {
      canUseShareTree: this.mainService.backupVersionUpdated && +this.mainService.backupVersionUpdated.substring(0, 3) >= 795,
      dataForPath: this.getValueForOperationsWithPath(toDiff),
      hid: this.mainService?.targetComputerData?.hid || this.mainService.hid,
      toDifferent: toDiff,
      isOffline: this.isOffline
    };
  }
}
